module.exports = __webpack_public_path__ + "static/media/mw2.37878f2c.webp";